var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 12c0 .675-.563 1.238-1.2 1.238h-5.4v5.4c0 .637-.563 1.162-1.2 1.162-.675 0-1.2-.525-1.2-1.163v-5.4H5.4c-.675 0-1.2-.562-1.2-1.237 0-.637.525-1.162 1.2-1.162h5.4v-5.4c0-.675.525-1.238 1.2-1.238.637 0 1.2.563 1.2 1.238v5.4h5.4c.637-.038 1.2.525 1.2 1.162z",
    fill: "currentColor"
  })));
}
export default SvgPlusIcon;